<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      accessToken: '',
      groupId: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    accessToken: { required },
    groupId: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      const access_token = this.accessToken.trim();
      const group_id = this.groupId.trim().replace(/\D/g, '') || this.groupId.trim();
      if (!group_id) {
        useAlert(this.$t('INBOX_MGMT.ADD.VK_CHANNEL.GROUP_ID.ERROR'));
        return;
      }

      try {
        const payload = await this.$store.dispatch('inboxes/createChannel', {
          channel: {
            type: 'vk',
            access_token,
            group_id: group_id,
          },
        });
        useAlert(this.$t('INBOX_MGMT.ADD.VK_CHANNEL.ACTIVATED'));
        router.replace({
          name: 'settings_inbox_show',
          params: { inboxId: payload.id },
        });
      } catch (error) {
        useAlert(error?.message || this.$t('INBOX_MGMT.ADD.VK_CHANNEL.CREATE_ERROR'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.VK_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.VK_CHANNEL.DESC')"
    />
    <p class="mb-4 text-sm text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.VK_CHANNEL.ADVANTAGES') }}
    </p>
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$?.accessToken?.$error }">
          {{ $t('INBOX_MGMT.ADD.VK_CHANNEL.ACCESS_TOKEN.LABEL') }}
          <input
            v-model="accessToken"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.VK_CHANNEL.ACCESS_TOKEN.PLACEHOLDER')"
            @blur="v$?.accessToken?.$touch"
          />
        </label>
      </div>
      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label :class="{ error: v$?.groupId?.$error }">
          {{ $t('INBOX_MGMT.ADD.VK_CHANNEL.GROUP_ID.LABEL') }}
          <input
            v-model="groupId"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.VK_CHANNEL.GROUP_ID.PLACEHOLDER')"
            @blur="v$?.groupId?.$touch"
          />
        </label>
        <p class="mt-1 text-xs text-n-slate-11">
          {{ $t('INBOX_MGMT.ADD.VK_CHANNEL.GROUP_ID.HINT') }}
        </p>
      </div>
      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.VK_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
